function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "info");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M14.2,16 C14.0499993,16 13.9250005,15.9500005 13.825,15.85 C13.7249995,15.7499995 13.675,15.6250008 13.675,15.475 L13.675,12.75 C13.675,12.5999993 13.7249995,12.4750005 13.825,12.375 C13.9250005,12.2749995 14.0499993,12.225 14.2,12.225 L15.9,12.225 C16.0500008,12.225 16.175,12.2749995 16.275,12.375 C16.3750005,12.4750005 16.425,12.5999993 16.425,12.75 L16.425,15.475 C16.425,15.6250008 16.3750005,15.7499995 16.275,15.85 C16.175,15.9500005 16.0500008,16 15.9,16 L14.2,16 Z M14.8,32 C14.4499983,32 14.1541679,31.8791679 13.9125,31.6375 C13.6708321,31.3958321 13.55,31.1000018 13.55,30.75 L13.55,20.525 L11.525,20.525 C11.3749993,20.525 11.2500005,20.4750005 11.15,20.375 C11.0499995,20.2749995 11,20.1500008 11,20 L11,18.2 C11,18.0499993 11.0499995,17.9250005 11.15,17.825 C11.2500005,17.7249995 11.3749993,17.675 11.525,17.675 L15.3,17.675 C15.6500018,17.675 15.9458321,17.7958321 16.1875,18.0375 C16.4291679,18.2791679 16.55,18.5749983 16.55,18.925 L16.55,29.15 L18.575,29.15 C18.7250007,29.15 18.8499995,29.1999995 18.95,29.3 C19.0500005,29.4000005 19.1,29.5249993 19.1,29.675 L19.1,31.475 C19.1,31.6250008 19.0500005,31.7499995 18.95,31.85 C18.8499995,31.9500005 18.7250007,32 18.575,32 L14.8,32 Z",
  id: "path-1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "info",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(1.000000, 1.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "i"
}, React.createElement("use", {
  fill: "#000000",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#ECE5D9",
  xlinkHref: "#path-1"
})), React.createElement("path", {
  d: "M-1,-1 L31,-1 L31,49 L-1,49 L-1,-1 Z M1,1 L1,47 L29,47 L29,1 L1,1 Z",
  id: "Rectangle-Copy-4",
  fill: "#ECE5D9"
})));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "50px",
    viewBox: "0 0 32 50",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.7fe0d269.svg";
export { ForwardRef as ReactComponent };